import wineStore from 'store/wineStore';
import wineListsStore from 'store/wineListsStore';
import wineLoversActivitiesStore from 'store/wineLoversActivitiesStore';
import usersStore from 'store/usersStore';
import wineLoversStore from 'store/wineLoversStore';
import partnersStore from 'store/partnersStore';
import domainData from 'store/domainStore';
import sidebarStore from 'store/ui/sidebarStore';
import dashboardStore from 'store/dashboardStore';

export default () => {
  // NOTE: uncomment this line if need to delete all local storage data
  // localStorage.clear();

  localStorage.removeItem('currentUser');
  localStorage.removeItem('currentServiceProvider');
  localStorage.removeItem('appTheme');
  localStorage.removeItem('dashboard_filter_params');
  localStorage.removeItem('wine_filter_params');
  localStorage.removeItem('wine_lists_filter_params');
  localStorage.removeItem('serviceProviders_filter_params');
  localStorage.removeItem('users_filter_params');
  localStorage.removeItem('wine_label_filter_params');
  localStorage.removeItem('wine_lovers_activities_filter_params');
  localStorage.removeItem('wine_lovers_filter_params');
  domainData.reset();
  sidebarStore.reset();
  wineStore.reset();
  wineListsStore.reset();
  usersStore.reset();
  partnersStore.reset();
  wineLoversStore.reset();
  wineLoversActivitiesStore.reset();
  dashboardStore.reset();
};
